var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgArrowGoForward5 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7H16V11L22 6L16 1V5H11C8.87827 5 6.84344 5.84285 5.34315 7.34315C3.84285 8.84344 3 10.8783 3 13C3 15.1217 3.84285 17.1566 5.34315 18.6569C6.84344 20.1571 8.87827 21 11 21H12V19H11C9.4087 19 7.88258 18.3679 6.75736 17.2426C5.63214 16.1174 5 14.5913 5 13C5 11.4087 5.63214 9.88258 6.75736 8.75736C7.88258 7.63214 9.4087 7 11 7ZM17.2841 22.7997C17.733 23.0128 18.2415 23.1193 18.8097 23.1193C19.4261 23.1193 19.9688 22.9915 20.4375 22.7358C20.9091 22.4773 21.277 22.1236 21.5412 21.6747C21.8082 21.223 21.9418 20.7088 21.9418 20.1321C21.9418 19.5725 21.8224 19.0753 21.5838 18.6406C21.3452 18.206 21.0185 17.8651 20.6037 17.6179C20.1889 17.3679 19.7173 17.2429 19.1889 17.2429C18.8366 17.2429 18.5128 17.3068 18.2173 17.4347C17.9219 17.5597 17.6932 17.7173 17.5312 17.9077H17.4801L17.7315 15.5938H21.4858V14.2727H16.4233L15.9673 18.7727L17.3949 19.0071C17.5426 18.8452 17.7429 18.7145 17.9957 18.6151C18.2486 18.5156 18.5057 18.4673 18.767 18.4702C19.0881 18.4702 19.3722 18.544 19.6193 18.6918C19.8665 18.8367 20.0611 19.0369 20.2031 19.2926C20.3452 19.5483 20.4148 19.8409 20.4119 20.1705C20.4148 20.4943 20.3466 20.7827 20.2074 21.0355C20.0682 21.2884 19.8778 21.4858 19.6364 21.6278C19.3949 21.7699 19.1193 21.8409 18.8097 21.8409C18.4148 21.8409 18.0767 21.7287 17.7955 21.5043C17.5142 21.277 17.3594 20.9844 17.331 20.6264H15.7969C15.8139 21.1094 15.9531 21.5384 16.2145 21.9134C16.4787 22.2884 16.8352 22.5838 17.2841 22.7997Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowGoForward5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-go-forward-5.cf23667f6e93d4eb61c6ca7c9d6f1fe9.svg";